/*
    This service registers the API interceptor after validating the successful SSO
*/

import registerInterceptors from '../registerInterceptors';

export const registerInterceptorsService = isUserLoggedIn => {
  if (isUserLoggedIn) {
    registerInterceptors();
  }
};
